import type { DriveStep } from "driver.js";

type CoachOverlayConfig = {
  overlayId: string;
  steps: DriveStep[];
};

/**
 * Step 4 — Agent overview page
 */
export const agentOverviewOverlay: CoachOverlayConfig = {
  overlayId: "agent-overview",
  steps: [
    {
      element: '[data-onboarding="agent-status"]',
      popover: {
        title: "Your agent",
        description: "This is your agent's home. You can see its name, tabs, and settings here.",
        side: "bottom",
        align: "start",
      },
    },
  ],
};

/**
 * Step 5 — Agent function page (debugger)
 */
export const agentFunctionOverlay: CoachOverlayConfig = {
  overlayId: "agent-function",
  steps: [
    {
      element: '[data-onboarding="try-it-button"]',
      popover: {
        title: "Try your agent",
        description: "Open the debugger to have a live conversation with your agent from the browser.",
        side: "left",
        align: "start",
      },
    },
  ],
};

/**
 * Step 6 — Sessions page
 */
export const sessionsOverlay: CoachOverlayConfig = {
  overlayId: "sessions",
  steps: [
    {
      element: '[data-onboarding="session-row"]',
      popover: {
        title: "Session list",
        description: "Each row is one conversation. Click any row to inspect it.",
        side: "bottom",
        align: "start",
      },
    },
    {
      element: '[data-onboarding="detail-tabs"]',
      popover: {
        title: "Detail tabs",
        description: "Switch between transcript, events, trace, and evaluations for the selected session.",
        side: "bottom",
        align: "start",
      },
    },
    {
      element: '[data-onboarding="transcript-view"]',
      popover: {
        title: "Transcript view",
        description: "Read the full conversation between your agent and the caller.",
        side: "left",
        align: "start",
      },
    },
  ],
};

/**
 * Step 6 (trace variant) — Sessions page with trace tab open
 */
export const sessionsTraceOverlay: CoachOverlayConfig = {
  overlayId: "sessions-trace",
  steps: [
    {
      element: '[data-onboarding="detail-tabs"]',
      popover: {
        title: "Trace tab",
        description: "The trace shows every step your agent took — LLM calls, tool use, latency — in a timeline view.",
        side: "bottom",
        align: "start",
      },
    },
    {
      element: '[data-onboarding="trace-view"]',
      popover: {
        title: "Trace viewer",
        description: "Expand any span to see inputs, outputs, and timing. Use this to debug issues and optimize performance.",
        side: "left",
        align: "start",
      },
    },
  ],
};

/**
 * Step 10 — Releases page
 */
export const releasesOverlay: CoachOverlayConfig = {
  overlayId: "releases",
  steps: [
    {
      element: '[data-onboarding="release-list"]',
      popover: {
        title: "Release history",
        description: "Every deploy creates a release. You can see status, environment, and who triggered it.",
        side: "top",
        align: "start",
      },
    },
    {
      element: '[data-onboarding="env-filter"]',
      popover: {
        title: "Filter by environment",
        description: "Narrow the list to a single environment like dev or production.",
        side: "bottom",
        align: "end",
      },
    },
  ],
};
